import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "text-xs leading-loose text-danger-500 mt-0.5"
}

import { ElSelect, ElOption } from 'element-plus';
import { OptionType } from '~src/admin/types';

// Props with default values

export default /*@__PURE__*/_defineComponent({
  __name: 'Select',
  props: /*@__PURE__*/_mergeModels({
    options: {},
    placeholder: { default: '' },
    errorMsg: { default: '' },
    disabled: { type: Boolean, default: false }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



// Store current value
const value = _useModel<string>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElSelect), {
      class: _normalizeClass(['custom-select', _ctx.errorMsg && 'custom-select-error']),
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      "popper-class": "select-options",
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createBlock(_unref(ElOption), {
            key: option.value,
            label: option.label,
            value: option.value
          }, null, 8, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["class", "modelValue", "placeholder", "disabled"]),
    (_ctx.errorMsg)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.errorMsg), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})